/*
  Simple CSV download utility methods for easy CSV downloads in the browser.
*/

export type CSVHeader<T> = {
  label: string
  key: keyof T
}

export function generateCSV<T> (headers: CSVHeader<T>[], data: T[]): string {
  const headerLine = headers.map(h => h.label).join(',')

  const rows = data.map(row =>
    headers.map(h => {
      const value = row[h.key]
      return `"${(value ?? '').toString().replace(/"/g, '""')}"`
    }).join(',')
  )

  return [headerLine, ...rows].join('\n')
}

export function downloadCSV (filename: string, csvContent: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()

  URL.revokeObjectURL(url)
}
